import templateUrl from "emun.cart/cart-forms.htm";
import controller from "emun.cart/cart-forms.controller";

export default {
	require: {
		//container: '^retailerContainer'
	},
	bindings: {
		disableQueryString: "<?",
		retailerId: "@",
		vendorFormId: "@",
		retailer: "<",
		formId: "@",
		hideForms: "<?",
		hideTitle: "<?"
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};
